import React from 'react';
import { SaiDashboardType } from '../../../graphQL';
import { useGetEmbedUrl } from '../hooks/useGetEmbedUrl';
import { LoadingPage } from '../../../Components/LoadingOverlay';
import { UnexpectedError } from '../../Shared';

type DashboardFrameProps = {
  dashboardKey: SaiDashboardType;
};

export const DashboardFrame = ({ dashboardKey }: DashboardFrameProps) => {
  const vm = useGetEmbedUrl({ dashboardKey });

  if (vm.status === 'loading') {
    return <LoadingPage />;
  }

  if (vm.status === 'error') {
    return <UnexpectedError message={vm.errorMessage} />;
  }

  return (
    <iframe
      title="Dashboard Frame"
      style={{ border: 'none', width: '100%', height: 'calc(100vh - 200px)' }}
      src={vm.embedUrl}
      allow="clipboard-write"
    />
  );
};
